import { FC, useMemo } from 'react'
import { Popover } from '@headlessui/react'
import { useInteractiveContext } from '@app/components/providers/interactive'
import { HomeManager } from '@app/managers'
import { classNames } from '@app/utils/classes'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { Website } from '@app/types'

const cellClassName = 'w-full text-left text-sm px-2 py-2 md:px-4 md:py-2.5'

const cellClassnameHover =
  'hover:opacity-70 hover:rounded-t hover:text-blue-600'

const WebsiteCellItem = ({
  domain,
  onClick,
}: {
  domain: string
  onClick(): void
}) => {
  return (
    <li className='w-full'>
      <Popover.Button
        className={classNames(cellClassName, cellClassnameHover)}
        onClick={onClick}
      >
        {domain}
      </Popover.Button>
    </li>
  )
}

export const AllWebsitesListMock: FC<{
  data: Website[]
  translation?: string
}> = ({ data, translation }) => {
  const { t } = useTranslation(translation || 'dashboard')

  const { setSelectedWebsite } = useInteractiveContext()

  const list = useMemo(() => data || [], [data])

  const onClickEvent = (domain: string) => {
    HomeManager.setDashboardDemoView(domain)
    setSelectedWebsite(domain)
  }

  const onViewAllEvent = () => {
    onClickEvent('')
  }

  const hasItems = list && list?.length

  return (
    <ul className='max-h-64 overflow-y-auto list-none shadow rounded border bg-white dark:bg-black'>
      <li>
        <Popover.Button
          onClick={onViewAllEvent}
          className={classNames(
            cellClassName,
            cellClassnameHover,
            hasItems ? 'border-b' : ''
          )}
        >
          {`${t('view')} ${t('all-sites')}`}
        </Popover.Button>
      </li>
      {list.map((item) => (
        <WebsiteCellItem
          key={item.domain}
          domain={item.domain}
          onClick={() => onClickEvent(item.url + '')}
        />
      ))}
    </ul>
  )
}
